define('router/router',['require','durandal/app','knockout','plugins/router','i18next','api-access','lib/auth/auth','api-access','web-urls','tealium-utils','popover-binder','mixpanel-helper','moment-timezone','moment-timezone-data','jquery-ui-helper','lib/set-language','router/router-tasks/initial-page-task','router/router-tasks/router-tasks','router/router-tasks/pre-fetch','router/router-tasks/trial-notifications-task','router/router-tasks/set-mixpanel-identity','router/router-tasks/initialize-gsu','router/router-tasks/set-first-endpoint-session-flag','disable-click'],function (require) {
    var app = require('durandal/app');
    var ko = require('knockout');
    var router = require('plugins/router');
    var i18n = require('i18next');
    var apiAccess = require('api-access');
    var auth = require('lib/auth/auth');
    var user = require('api-access').user;
    var webUrls = require('web-urls');
    var tealiumUtils = require('tealium-utils');
    var popover = require('popover-binder');
    var mixpanelHelper = require('mixpanel-helper');
    var moment = require('moment-timezone');
    var momentTimezoneData = require('moment-timezone-data');
    var datepickerHelper = require('jquery-ui-helper');
    var setLanguage = require('lib/set-language');

    var initialPageTask = require('router/router-tasks/initial-page-task');
    var routerTasks = require('router/router-tasks/router-tasks');
    var preFetch = require('router/router-tasks/pre-fetch');
    var showNotifications = require('router/router-tasks/trial-notifications-task');
    var setMixpanelIdentity = require('router/router-tasks/set-mixpanel-identity');
    var initializeGSU = require('router/router-tasks/initialize-gsu');
    var initializeEPFlags = require('router/router-tasks/set-first-endpoint-session-flag');

    require('disable-click');

    // Load timezone data
    moment.tz.load(momentTimezoneData);

    var self = this;

    // Promise that resolves when composition completes.
    var compositionCompletePromise = $.Deferred();

    var isInitialNavigation = true;

    self.trackLink = mixpanelHelper.trackLink;
    self.popover = popover;

    self.navigate = function (route) {
        return router.navigate(route);
    };

    self.embeddedLauncherDir = ko.observable('');
    require(
        ['launch'],
        function () {
            self.embeddedLauncherDir('meetings/launcher/embedded-launcher');
        },
        function () {
            self.embeddedLauncherDir('');
        }
    );

    // "Hello, John" in the expandable menu.
    self.greeting = ko.observable();

    app.on('user:timeout', function () {
        // Navigate to login screen
        window.location = '/';
    });

    // Only initialize the modals after composition is complete, so the route is finalized.
    var initializeModals = function (activeInstruction) {
        if (activeInstruction && activeInstruction.config.id === 'meetings') {
            routerTasks.pluginModal();
            showNotifications(activeInstruction);
        }
    };

    /**
     * Setup function that executes for authenticated users only.
     * returns a promise that resolves when critical requests complete.
     */
    var authenticatedSetup = function () {
        // Setting the language is the only critical task that should block for now.
        return setLanguage().then(function () {
            apiAccess.configure({locale: i18n.lng()});
            preFetch();
            routerTasks.greeting().then(function (greeting) {
                self.greeting(greeting);
            });
            setMixpanelIdentity();
            routerTasks.rememberUser();
            datepickerHelper.setDatepickerLocale(i18n.lng());

            compositionCompletePromise.then(function () {
                initializeGSU();
                initializeEPFlags();
                initializeModals(router.activeInstruction());
                router.activeInstruction.subscribe(initializeModals);
            });
        });
    };

    var handleInitialPageRedirects = function () {
        return initialPageTask().then(function (navigationPage) {
            // updating flag here as we don't have navigation route for different app
            if (navigationPage === webUrls.get('setsaleUrl')) {
                var setInsightsFlagPromise = $.Deferred();
                setTimeout(function () { setInsightsFlagPromise.resolve(navigationPage) }, 1000);
                user.updateSettings({setSaleAnalyticsTabShown: true}).then(function () {
                    setInsightsFlagPromise.resolve(navigationPage);
                });
                return setInsightsFlagPromise;
            }
            return navigationPage;
        });
    };

    var activate = function () {
        tealiumUtils.trackVirtualPages(router);

        router.guardRoute = function (instance, instruction) {
            if (instruction.config.authorizationRequired) {
                auth.ensureTokenSet({hash: instruction.fragment});
            }

            function initialRedirects() {
                if (!isInitialNavigation) {
                    return $.Deferred().resolve(true).promise();
                }

                return handleInitialPageRedirects()
                    .then(function (initialPage) {
                        // if the fragment is not empty or is the initial page already (re-entry)
                        // we just allow it by returning true
                        if (instruction.fragment === initialPage || instruction.fragment !== '') {
                            return true;
                        }

                        // if not force an initial page
                        return initialPage;
                    });
            }

            return initialRedirects().then(function (initialPageResponse) {
                isInitialNavigation = false;

                return initialPageResponse;
            });
        };

        /**
         * Route Configuration
         *
         * nav: Will add route to Durandal navigation model.
         * title: Document title.
         * text: String used to populate the main menu.
         *          If either are false, the text doesn't seem to show up.
         * id: ID inserted into the DOM
         * authorizationRequired: If true, router.guardRoute will check if the user is authenticated
         *                        and redirect if that needs to happen.
         *
         * For all changes to the routing, there should be a corresponding change in the tracking!
         */
        router.map([
            {
                route: ['meetings*details', ''],
                moduleId: 'meetings/meetings',
                nav: true,
                text: 'myMeetings.selection.upcoming',
                authorizationRequired: true,
                id: 'meetings'
            },
            {
                route: 'sessionInProgress',
                moduleId: 'meetings/meetings',
                nav: false,
                authorizationRequired: true,
                id: 'sessionInProgress'
            },
            {
                route: 'schedule',
                moduleId: 'meetings/meetings',
                nav: false,
                authorizationRequired: true,
                id: 'schedule'
            },
            {
                route: 'trialEnding',
                moduleId: 'meetings/meetings',
                nav: false,
                authorizationRequired: true,
                id: 'trialEnding'
            },
            {
                route: 'setup-error',
                moduleId: 'setup/error/error',
                nav: false,
                authorizationRequired: true,
                id: 'setup-error'
            },
            {
                route: ['setup*details'],
                moduleId: 'setup/setup',
                nav: false,
                authorizationRequired: true,
                id: 'setup'
            },
            {
                route: 'reserve',
                moduleId: 'setup/reserve',
                nav: false,
                authorizationRequired: true,
                id: 'reserve'
            },
            {
                route: 'settings',
                title: i18n.translate('settings.headline'),
                moduleId: 'settings/settings',
                text: 'links.g2m.audiosettings',
                nav: true,
                authorizationRequired: true,
                id: 'settings'
            },
            {
                route: 'settings/:enablePresenterSwapPopover',
                title: i18n.translate('settings.headline'),
                moduleId: 'settings/settings',
                text: 'links.g2m.audiosettings',
                nav: true,
                authorizationRequired: true,
                id: 'settingsEnablePresenterSwapPopover'
            },
            {
                route: ['labs', 'beta'],
                title: i18n.translate('labs.headline'),
                moduleId: 'labs/labs',
                nav: true,
                text: 'links.g2m.labs',
                authorizationRequired: true,
                id: 'labs'
            },
            {
                route: 'inviteUsers',
                title: 'Invite Users',
                moduleId: 'user/invite-users',
                nav: false,
                text: 'Invite Users',
                authorizationRequired: true,
                id: 'inviteUsers'
            },
            {
                route: 'number-change',
                title: 'Number Change',
                moduleId: 'meetings/lib/phone-number-change/phone-number-change',
                nav: true,
                text: 'Number Change',
                authorizationRequired: true,
                id: 'number-change'
            },
            {
                route: 'numbers/primary/:meetingId',
                title: i18n.translate('primaryNumber.headline'),
                moduleId: 'audio/display'
            },
            {
                route: 'numbers/alternate/:meetingId',
                title: i18n.translate('alternateNumber.headline'),
                moduleId: 'audio/numbers'
            },
            {
                route: 'codec',
                title: 'Codec',
                moduleId: 'codec/codec'
            },
            // failures
            {
                route: 'internalServerError',
                title: i18n.translate('error.500.headline'),
                moduleId: 'error/internalServerError'
            },
            {
                route: 'pageNotFound',
                title: i18n.translate('error.404.headline'),
                moduleId: 'error/pageNotFound'
            },
            {
                route: 'unsupportedBrowser',
                title: 'unsupportedBrowser',
                moduleId: 'error/unsupportedBrowser'
            }
        ])
            .buildNavigationModel()
            .mapUnknownRoutes('error/pageNotFound', 'not-found');

        if (auth.getToken()) {
            return authenticatedSetup().then(function () {
                return router.activate();
            });
        }

        return router.activate();
    };

    var compositionComplete = function () {
        compositionCompletePromise.resolve();
    };

    return {
        router: router,
        activate: activate,
        compositionComplete: compositionComplete,
        compositionCompletePromise: compositionCompletePromise
    };
});

